// removed by extract-text-webpack-plugin
module.exports = {"container":"_2nn5sZtA5q5BQ1Ar29h2LO","label":"_3YgV67l_1bwK_br3It7gL7","left":"_1p-wk_p08nVe470diudbU8","right":"YChS1N-R8Nn1DbaMu_Ml","slider":"_2n_KfYZ5CMkSox75bLicxn","rail":"_3AyUTon05mfOqs4FhTNsCZ","dot":"_33XkpwMXk5lPu0_MGJUKCS","clicked":"JfDogDtwDrhVqWYrXQpGd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Slider.css
// module id = 164
// module chunks = 0